package com.iregained.eventapp.components.widgets.styles

import com.iregained.eventapp.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

val PrimaryButtonStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        Modifier.backgroundColor(palette.brand.primary).color(palette.custom.lightGray) // White/Light text
            .border(1.px, LineStyle.Solid, palette.brand.primary).transition(
                Transition.of(TransitionProperty.All, duration = 300.ms)
            )
    }
    hover {
        val palette = colorMode.toSitePalette()
        Modifier.backgroundColor(palette.brand.primaryHover).border(1.px, LineStyle.Solid, palette.brand.primaryHover)
            .translateY((-2).px) // Subtle lift effect
            .boxShadow(0.px, 4.px, 10.px, color = palette.brand.primary.toRgb().copyf(alpha = 0.3f))
    }
}

val SecondaryButtonStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        Modifier.backgroundColor(palette.nearBackground) // Transparent/Background
            .color(palette.brand.primary) // Teal text
            .border(2.px, LineStyle.Solid, palette.brand.primary).transition(
                Transition.of(TransitionProperty.All, duration = 300.ms)
            )
    }
    hover {
        val palette = colorMode.toSitePalette()
        Modifier.backgroundColor(palette.brand.primary).color(palette.custom.lightGray).translateY((-2).px)
            .boxShadow(0.px, 4.px, 10.px, color = palette.brand.primary.toRgb().copyf(alpha = 0.2f))
    }
}

val HeaderSecondaryActionStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        // adaptaions made for standard secondary button
        Modifier.backgroundColor(palette.nearBackground).color(palette.brand.primary)
            .border(2.px, LineStyle.Solid, palette.brand.primary)
            .transition(Transition.of(TransitionProperty.All, duration = 300.ms))
    }
    hover {
        val palette = colorMode.toSitePalette()
        // adaptaions made for secondary hover effect
        Modifier.backgroundColor(palette.brand.primarySoft).translateY((-2).px)
            .boxShadow(0.px, 4.px, 10.px, color = palette.brand.primary.toRgb().copyf(alpha = 0.2f))
    }
}